module.exports = __webpack_public_path__ + "static/campo-lab-141c6f57159cd537dcf1b2ae284cd015.png";